<template>
  <div>
    <v-container fluid grid-list-xl px-0 py-2>
      <v-layout row wrap>
        <v-flex sm12 md8>
          <v-img width="100%" :src="'/static/img/giftcard-' + $i18n.locale + '.jpg'" class="giftcard">
            <div class="giftcard-text">
              <div class="name">{{ form.name }}</div>
              <div class="amount">{{ form.amount | currency }}</div>
              <div class="code"></div>
              <div class="date">{{ validitUntil }}</div>
            </div>
          </v-img>
          <div v-if="giftcardInfo" class="mt-5">
            <h2 class="mb-4">{{ giftcardInfo.title }}</h2>
            <div v-html=" giftcardInfo.excerpt"></div>
          </div>
        </v-flex>
        <v-flex sm12 md4>
          <base-card color="accent" class="pa-3">
            <h2 class="my-4">{{ $t('MENU.GIFT_CARD') }}</h2>
            <p>{{ $t('GIFT_CARD.FORMAT_INFO') }}</p>
            <v-form @submit.prevent="submit" class="my-4">
              <v-text-field
                v-model="form.name"
                required
                maxlength="18"
                :error-messages="errors.name"
                :label="$t('GIFT_CARD.NAME_OF_RECIPIENT')"
                @focus="errors.name = null"
              />
              <v-text-field
                v-model="form.amount"
                type="number"
                min="10"
                max="8000"
                required
                :error-messages="errors.amount"
                :label="$t('GIFT_CARD.AMOUNT')"
              />
              <div class="text-xs-right">
                <tk-btn type="submit" color="primary">{{ $t('ARTWORK.ADD_GIFT_CARD') }}</tk-btn>
              </div>
            </v-form>
          </base-card>
          <base-card v-if="$cart.giftCards.length" color="accent" class="mt-5 pa-3">
            <h2 class="my-4">{{ $t('GIFT_CARD.YOUR_ORDER') }}</h2>
            <v-layout row pl-3 pb-2>
              <v-flex xs6 pa-0>
                <div class="subheading font-weight-bold">{{ $t('GIFT_CARD.PRODUCT_NAME')}}</div>
              </v-flex>
              <v-flex xs4 pa-0>
                <div class="subheading font-weight-bold">{{ $t('CART.TOTAL')}}</div>
              </v-flex>
              <v-flex xs2 pa-0></v-flex>
            </v-layout>
            <v-divider/>
            <div row v-for="(order, i) in $cart.giftCards" :key="i">
              <v-layout pl-3 align-center>
                <v-flex xs6 pa-0 pt-2>{{ order.name }}</v-flex>
                <v-flex xs4 pa-0 pt-2>{{ order.amount | currency }}</v-flex>
                <v-flex xs2 pa-0 pt-2 @click="$cart.removeGiftCard(i)">
                  <tk-btn flat icon>
                    <v-icon size="16">fas fa-times</v-icon>
                  </tk-btn>
                </v-flex>
              </v-layout>
              <v-divider/>
            </div>
            <v-layout row pl-3 py-2>
              <v-flex xs6 pa-0>
                <div class="subheading font-weight-bold">{{ $t('CART.TOTAL')}}</div>
              </v-flex>
              <v-flex xs4 pa-0>
                <div class="subheading font-weight-bold">{{ $cart.giftCardTotal | currency }}</div>
              </v-flex>
              <v-flex xs2 pa-0></v-flex>
            </v-layout>

            <v-checkbox
              class="my-3"
              v-model="$cart.printGiftCard"
              color="primary"
              hide-details
              :label="$t('GIFT_CARD.PRINT_LABEL')"
              :ripple="false"
              v-if="$cart.giftCardTotal >= 200"
            />
            <tk-btn
              class="mt-4"
              block
              type="button"
              color="primary"
              :to="{ name: 'giftcard.checkout' }"
            >{{ $t('CART.CHECKOUT') }}</tk-btn>
          </base-card>
          <tk-payment-options class="mt-4" />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { ErrorHandler } from '@/utils/ErrorHandler'

const handler = new ErrorHandler();

export default {
  components: {
    TkPaymentOptions: () => import("@/components/core/TkPaymentOptions")
  },

  data() {
    return {
      form: {},
      errors: {
        amount: []
      },
      giftcardInfo: null
    };
  },

  computed: {
    validitUntil() {
      const date = new Date();
      date.setMonth(date.getMonth() + 6);
      return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
    }
  },
  created() {
    this.fetchGiftcardInfo();
  },
  methods: {
    submit() {
      this.errors.amount = [];
      if (!this.form.name || !this.form.amount) return;
      if (this.form.amount < 10 || this.form.amount > 8000) {
        this.errors.amount.push(this.$t("GIFT_CARD.INVALID_AMOUNT"));
        console.log(this.errors);
        return;
      }
      // this.$cart.addGiftCard(this.form); // This doesn't work. It adds reactive data form to list
      this.$cart.addGiftCard(Object.assign({}, this.form));
    },
    async fetchGiftcardInfo() {
      await handler.handle(async () => {
        const res = await this.$axios.get(`pages/giftcardinfo`);
        this.giftcardInfo = res.data["data"];
        this.$emit('update:giftcardInfo', this.giftcardInfo)
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.giftcard {
  border: 1px solid #000;
  font-size: 1.5rem;
  .giftcard-text {
    position: absolute;
    top: 0;
    right: 0px;
    width: 50%;
    height: 100%;
    .name {
      padding: 8% 0 0 0;
      margin: 0;
      height: 20%;
      text-align: center;
      width: 100%;
      color: #000;
      font-weight: 600;
    }
    .amount {
      padding: 2% 0 0 0;
      margin: 7% 0 0 0;
      height: 11%;
      text-align: center;
      color: #000;
      font-weight: 600;
    }
    .code {
      padding: 2% 0 0 0;
      margin: 10% 0 0 0;
      height: 15%;
      color: #000;
      font-weight: 600;
      text-align: center;
      font-size: 2.1rem;
      &:after {
        content: " ***** ";
      }
    }
    .date {
      height: 15%;
      color: #000;
      text-align: center;
      padding: 3% 0 0 0;
      margin: 14% 0 0 0;
      font-size: 1rem;
    }

    @media screen and (max-width: 540px) {
      .name,
      .code,
      .date,
      .amount {
        font-size: 1rem;
      }
    }
  }
}
</style>
